import EformBaseService from '../../../../services/EformBaseService'

export default class FDRService extends EformBaseService {

  constructor() {
    super('wbf/bwo/fdr')
  }

}
